import React from 'react'

import styles from './styles.module.css'
import { Typography, LinearProgress } from "@mui/material"


export default function DashContainer({ title, loading, children }) {
    return (
        <>
            <DashboardHeader title={title} />
            {
                loading && <LinearProgress />
            }
            {
                !loading && (
                    <div className={styles.dashboardContent}>
                        {children}
                    </div>
                )
            }
        </>
    )
}

export const DashboardHeader = ({ title, sub, children, renderMore = () => null }) => (
    <div className={styles.dashboardHeader}>
        <div className={styles.dashboardTitle}>
            <div style={{ flex: 1, display: 'flex', alignItems: 'center', gap: 20 }}>
                <Typography variant="h6">{title} <span className={styles.dashboardSubtitle}>{sub}</span></Typography>
                {renderMore()}
            </div>
            {children}
        </div>
    </div>
)

export const DashboardBody = ({ loading, children, variant = "default" }) => {
    const className = ({
        "default": styles.dashboardContentBody,
        "nopad": styles.dashboardContentBodyNoPad,
    })[variant]

    return (
        <>
            {
                loading && <LinearProgress />
            }
            {
                !loading && (
                    <div className={className}>
                        {children}
                    </div>
                )
            }
        </>
    )
}